import { GuardedComponent } from '../components/guarded-component';
import { ManageLeave } from '../features/manage-leave/manage-leave.page';
import { ContactsPage } from '../features/masters/contact/contacts.page';
import { MasterDashboard } from '../features/masters/dashboard/master-dashboard.page';
import { DepartmentPage } from '../features/masters/department/department.page';
import { DivisionPage } from '../features/masters/division/divisions.page';
import { CreateEmployeePage } from '../features/masters/employee/create-employee/create-employee.page';
import { EditEmployeePage } from '../features/masters/employee/create-employee/edit-employee.page';
import { EmployeesPage } from '../features/masters/employee/employees.page';
import EmployeeProfilePage from '../features/masters/employee/profile/employee-profile.page';
import { EquipmentsPage } from '../features/masters/equipment/equipments.page';
import { HolidayManagementPage } from '../features/masters/holiday-management/holiday-management.page';
import { MarketAreasPage } from '../features/masters/market-area/market-area.page';
import { CreateMunicipalityPage } from '../features/masters/municipality/create_municipality/create_municipality.page';
import { EditMunicipalityPage } from '../features/masters/municipality/create_municipality/edit_municipality.page';
import { MunicipalityDetailsPage } from '../features/masters/municipality/details-municipality/municipality-details.page';
import { MunicipalityPage } from '../features/masters/municipality/municipality.page';
import { ProjectSubtypePage } from '../features/masters/project-subtype/project-subtype.page';
import { QuickBookResultPage } from '../features/masters/quick-book/quick-book-resul.page';
import { QuickBookPage } from '../features/masters/quick-book/quickbook.page';
import { RebateCompanyPage } from '../features/masters/rebate-company/rebate-company.page';
import { RolesPage } from '../features/masters/role/roles.page';
import { ServiceCategoryPage } from '../features/masters/service-category/service-categories.page';
import { ServiceGroupPage } from '../features/masters/service-group/service-groups.page';
import { ServiceTypePage } from '../features/masters/service-type/service-type.page';
import { ServicesPage } from '../features/masters/service/services.page';
import { SkillSetPage } from '../features/masters/skill-set/skill-set.page';
import { UserPermissionName } from '../models/user-permission-name';

export const MastersRoute = {
  path: '/masters',
  children: [
    {
      index: true,
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_MASTER]} showPermissionError>
          <MasterDashboard />
        </GuardedComponent>
      ),
    },
    {
      path: 'skill-set',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_SKILLSET]} showPermissionError>
          <SkillSetPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'service',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_SERVICE]} showPermissionError>
          <ServicesPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'employee',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_EMPLOYEE]} showPermissionError>
          <EmployeesPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'employee/create',
      name: 'Create Employee',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.ADD_EMPLOYEE]} showPermissionError>
          <CreateEmployeePage />
        </GuardedComponent>
      ),
    },
    {
      path: 'employee/edit/:id',
      name: 'Edit Employee',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.EDIT_EMPLOYEE]} showPermissionError>
          <EditEmployeePage />
        </GuardedComponent>
      ),
    },
    // {
    //   path: 'units',
    //   element: (
    //     <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_MASTER]} showPermissionError>
    //       <UnitsPage />
    //     </GuardedComponent>
    //   ),
    // },
    {
      path: 'equipment',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_EQUIPMENT]} showPermissionError>
          <EquipmentsPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'municipality',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_MUNICIPALITY]} showPermissionError>
          <MunicipalityPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'municipality/details/:id',
      name: 'Municipality Details',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_MUNICIPALITY]} showPermissionError>
          <MunicipalityDetailsPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'municipality/create',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.ADD_MUNICIPALITY]} showPermissionError>
          <CreateMunicipalityPage />
        </GuardedComponent>
      ),
    },
    // {
    //   path: 'employee/profile/:id',
    //   name: 'Profile',
    //   element: (
    //     <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_EMPLOYEE]} showPermissionError>
    //       <EmployeeProfilePage />
    //     </GuardedComponent>
    //   ),
    // },
    {
      path: 'municipality/edit/:municipalityID',
      name: 'Edit ',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.EDIT_MUNICIPALITY]} showPermissionError>
          <EditMunicipalityPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'market-area',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_MARKET_AREA]} showPermissionError>
          <MarketAreasPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'role',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_ROLE]} showPermissionError>
          <RolesPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'manage-leave',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_LEAVE]} showPermissionError>
          <ManageLeave />
        </GuardedComponent>
      ),
    },
    {
      path: 'division',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_DIVISION]} showPermissionError>
          <DivisionPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'service-category',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_SERVICECATEGORY]} showPermissionError>
          <ServiceCategoryPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'service-group',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_SERVICEGROUP]} showPermissionError>
          <ServiceGroupPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'service-type',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_SERVICETYPE]} showPermissionError>
          <ServiceTypePage />
        </GuardedComponent>
      ),
    },
    {
      path: 'quickbook',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_MASTER]} showPermissionError>
          <QuickBookPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'quickbook_result',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_MASTER]} showPermissionError>
          <QuickBookResultPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'rebate-company',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_REBATECOMPANY]} showPermissionError>
          <RebateCompanyPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'project-subtype',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_PROJECTSUBTYPE]} showPermissionError>
          <ProjectSubtypePage />
        </GuardedComponent>
      ),
    },
    {
      path: 'contact',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_CONTACT]} showPermissionError>
          <ContactsPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'department',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_DEPARTMENT]} showPermissionError>
          <DepartmentPage />
        </GuardedComponent>
      ),
    },
    {
      path: 'holiday-management',
      element: (
        <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_HOLIDAY]} showPermissionError>
          <HolidayManagementPage />
        </GuardedComponent>
      ),
    },
  ],
};
